import { createApp } from "vue";
import store from "store";
import App from "./App";

createApp(App).use(store).mount("#block-event-contributors-block");
